import script from "./TariffPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffPopup.vue?vue&type=script&setup=true&lang=js"

import "./TariffPopup.vue?vue&type=style&index=0&id=ae556354&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae556354"]])

export default __exports__